/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free fixed deposit (FD) calculator. Enter your deposit, interest rate and tenure to estimate the maturity amount and interest earned.`)
};

const es_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de depósito fijo (FD) gratuita. Ingresa tu depósito, tasa de interés y plazo para estimar el monto de vencimiento e interés ganado.`)
};

const de_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Festgeldanlage (FD)-Rechner. Geben Sie Ihre Einzahlung, Zinsrate und Laufzeit ein, um den Fälligkeitsbetrag und verdiente Zinsen zu schätzen.`)
};

const nl_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis vaste storting (FD) calculator. Voer uw storting, rentevoet en periode in om het bedrag en verdiende rente bij afloop in te schatten.`)
};

const fr_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice gratuite de dépôt fixe (FD). Entrez votre dépôt, le taux d'intérêt et la durée pour estimer le montant à maturité et les intérêts gagnés.`)
};

const it_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore deposito fisso (FD) gratuito. Inserisci il tuo deposito, il tasso di interesse e la durata per stimare l'importo a scadenza e l'interesse guadagnato.`)
};

const pt_br2_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de depósito fixo (FD) gratuita. Digite seu depósito, taxa de juros e prazo para estimar o valor de vencimento e juros ganhos.`)
};

const pt_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de depósito fixo (FD) gratuita. Introduza o seu depósito, taxa de juro e prazo para estimar o montante de maturidade e juro auferido.`)
};

const ja_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の定期預金(FD)計算機。預金額、利率、満期期間を入力して、満期金額と利息を推定します。`)
};

const zh_sip_fd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费定期存款（FD）计算器。输入您的存款、利率和期限，估算到期金额和利息收入。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_meta_description", locale)
	if (locale === "en") return en_sip_fd_meta_description(inputs)
	if (locale === "es") return es_sip_fd_meta_description(inputs)
	if (locale === "de") return de_sip_fd_meta_description(inputs)
	if (locale === "nl") return nl_sip_fd_meta_description(inputs)
	if (locale === "fr") return fr_sip_fd_meta_description(inputs)
	if (locale === "it") return it_sip_fd_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_meta_description(inputs)
	if (locale === "pt") return pt_sip_fd_meta_description(inputs)
	if (locale === "ja") return ja_sip_fd_meta_description(inputs)
	return zh_sip_fd_meta_description(inputs)
};